import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'cars/car';
const model = 'cars/car';
const wizardName = 'Contract association';
const wizardObject = 'Contract';
const wizardAction = 'contractAssociation';

const ContractAssociation = (params) => {
    const { t } = useTranslation();
    const { userCapabilities } = useContext(AppContext);

    const carRecordId = params?.id ?? params?.car?.id ?? params?.car?._id ?? null;
    const { doAction, item, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart, carRecordId);
    const car = params?.car ?? item?.data;

    const detailConfig = {
        "tabs": [
            {
                "name": "association",
                "fieldsets": [
                    {
                        "name": "association",
                        "fields": {
                            "available_contracts": {
                                "type": "sectiontitle",
                                "className": "col-12"
                            },
                            "associated": {
                                "type": "contractlist",
                                "defaultSelectedValues": [],
                                "enableSelection": true,
                                "disableMultipleRowSelection": true,
                                "dataProviderName": "cars/contract",
                                "className": "col-12",
                                "required": "true",
                                "filters": {
                                    "items": [
                                        {
                                            "field": "_related_car_id",
                                            "operator": "isEmpty"
                                        },
                                        {
                                            "field": "contractIdentifier",
                                            "operator": "isNotEmpty"
                                        },
                                        {
                                            "field": "legal_entity_id",
                                            "operator": "equals",
                                            "value": car?.legal_entity_id
                                        },
                                    ]
                                }
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    const [editing, setEditing] = useState(false)

    useEffect(() => {
        if (success && editing) {
            (async () => {
                try {
                    await params.handleClose(params.uid, item.data)
                } catch (e) { }
            })()
        }
    }, [success])
    
    const handleSave = (data) => {
        doAction({ action: wizardAction, model: dataProviderName, data: data });
    }

    return <>
        <DetailComponent
            disableDetailConfigOverride={true}
            values={{ 
                "id": car?._id ?? car?.id
            }}
            modelName={model.split('/')[1]}
            detailConfig={detailConfig}
            dataProviderName={dataProviderName}
            onEditing={setEditing}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t(wizardName)}
            canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
            header={
                <InfoHeader
                    view="wizard"
                    title={t(wizardName)}
                    subtitle={t('Select a {{wizardObject}} to be associated to {{carIdentifier}}', { wizardObject: wizardObject, carIdentifier: (car?.plate ? car.plate : car?.setup?.make + " " + car?.setup?.model) })}
                />
            }
            {...params}
        />
    </>
}

export default ContractAssociation;


